import {Map, OrderedMap} from 'immutable'

import {
  SET_RECENT_CONVERSATIONS
} from '../action_types'

export default (state = Map({}), action) => {
  switch (action.type) {
    case SET_RECENT_CONVERSATIONS:
      const convs = OrderedMap(action.recentConversations)
        .map((c, key) => Map(c).merge({uid: key}).toObject())
        .sortBy((c) => c.latestMessageTime ? -1 * c.latestMessageTime : 0)

      return convs

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/recent_conversations.js
 **/